const TABS = {
  perso: 'personal_infos',
  contact: 'contact_infos',
  bank: 'bank_infos',
  docs: 'documents',
}

const ACTIONS = {
  update: 'update',
  save: 'save',
  cancel: 'cancel',
}

export { TABS, ACTIONS }
